// Textos de los errores del API (WS-2311). Las claves son los códigos tal cual
// llegan del backend (catálogo: backend .documentation/secciones/errores/
// catalogo-codigos-api.md); los lee src/app/utils/api-error.ts. Un código que
// no esté aquí se muestra con el `message` del servidor.
export const locale = {
  lang: 'es',
  data: {
    API_ERRORS: {
      // Mensaje de un 422 con varios errores: el primero y cuántos más hay
      AND_MORE: '{{message}} (y {{count}} más)',

      // `error_type`: genéricos (ApiErrorCodeEnum) y sueltos
      TYPE: {
        resource_not_found: 'No hemos encontrado el recurso solicitado.',
        action_unauthorized: 'No tienes permisos para realizar esta acción.',
        internal_error: 'Se ha producido un error inesperado. Inténtalo de nuevo en unos minutos.',
        save_failed: 'No se ha podido guardar. Inténtalo de nuevo en unos minutos.',
        load_failed: 'No se han podido cargar los datos. Inténtalo de nuevo en unos minutos.',
        headquarters_already_exists: 'La empresa ya tiene sede central.',
        delete_failed: 'No se ha podido eliminar. Inténtalo de nuevo en unos minutos.',
        upstream_unavailable: 'El servicio no está disponible en este momento. Inténtalo de nuevo más tarde.',

        // Flotas de taxi/VTC (docs/flotas-drivers/api-contract.md)
        fleet_onboarding_incomplete: 'Faltan pasos del alta por completar.',
        legal_texts_outdated: 'Los textos legales han cambiado. Revísalos y acéptalos de nuevo.',
        membership_not_pending: 'Esta solicitud ya no está pendiente. Recarga la lista.',
        vehicle_plate_taken: 'Esta matrícula ya está dada de alta en una flota.',
        shifts_locked: 'Para asignar turnos hace falta al menos un vehículo y un conductor aceptado.',
        shifts_outdated: 'Alguien ha cambiado los turnos mientras los editabas. Vuelve a cargarlos.',
        shift_conflict: 'Hay conflictos en los turnos. Revisa las celdas marcadas.',
        member_already_exists: 'Esta persona ya está en el equipo.',
        last_owner: 'La flota tiene que tener al menos un propietario.',
        document_already_reviewed: 'Otra persona ya ha revisado este documento. Recarga la cola.',
        billing_not_in_review: 'Los datos de facturación ya no están pendientes de revisión. Recarga la ficha.',

        account_banned: 'La cuenta está bloqueada. Contacta con soporte para reactivarla.',
        already_decided: 'Esta retirada ya se aprobó o rechazó antes. Recarga la ficha.',
        already_has_matches: 'La rutina ya tiene matches y no se puede modificar.',
        birth_date_required: 'Falta la fecha de nacimiento del usuario, necesaria para abrir su cuenta de cobro.',
        campaign_not_cancellable: 'La campaña ya está cerrada y no se puede cancelar.',
        card_already_canceled: 'La tarjeta está cancelada y ya no se puede modificar.',
        card_generation_disabled: 'La emisión de tarjetas está desactivada en este momento.',
        card_not_eligible_not_in_driver_program: 'El usuario no está en el programa de conductores, así que no le corresponde tarjeta.',
        card_not_eligible_pilot_restricted: 'La tarjeta está en una prueba piloto y este usuario no forma parte de ella.',
        card_not_found: 'El usuario no tiene ninguna tarjeta de conductor.',
        card_not_issued_yet: 'La tarjeta todavía no se ha emitido.',
        conflict: 'Otra operación se ha guardado a la vez. Recarga e inténtalo de nuevo.',
        coupon_already_applied: 'El usuario ya ha aplicado este cupón.',
        coupon_expired: 'El cupón ha caducado.',
        coupon_not_active_yet: 'El cupón todavía no está activo.',
        coupon_not_eligible: 'El cupón no es aplicable a este usuario.',
        coupon_not_found: 'No hemos encontrado el cupón.',
        date_overlap: 'Las fechas y horarios de la rutina coinciden con otra rutina del usuario.',
        document_already_in_use: 'Este documento de identidad ya está asociado a otra cuenta.',
        document_data_unreadable: 'No se han podido leer los datos del documento escaneado.',
        document_mismatch: 'Los datos del carnet de conducir no coinciden con los del documento de identidad.',
        document_not_scanned: 'No se ha leído el carnet de conducir. Hay que volver a escanearlo.',
        document_verification_required: 'Hay que verificar el documento de identidad antes de añadir una cuenta bancaria.',
        empty_segment: 'El segmento no tiene destinatarios disponibles.',
        face_verification_already_completed: 'Esta verificación facial ya ha terminado.',
        face_verification_already_passed: 'El usuario ya ha superado la verificación facial para este viaje.',
        face_verification_not_required: 'Este usuario no necesita verificación facial.',
        face_verification_provider_unavailable: 'El servicio de verificación facial no responde. Inténtalo de nuevo más tarde.',
        face_verification_required: 'Hay que superar la verificación facial antes de finalizar el viaje.',
        feature_locked: 'Esta sección no está incluida en el plan contratado por la empresa.',
        field_not_editable: 'Este campo no se puede editar.',
        group_not_cancellable: 'El grupo no tiene ninguna campaña activa que cancelar.',
        iban_already_registered: 'Este IBAN ya está registrado en la cuenta.',
        identity_data_missing: 'Faltan datos de la identidad verificada para comparar el documento.',
        identity_document_mismatch: 'El documento escaneado no es el mismo que el de la cuenta.',
        identity_mismatch: 'Los datos del documento no coinciden con los de la cuenta.',
        import_already_running: 'Ya hay una importación de POIs en curso. Espera a que termine antes de lanzar otra.',
        insufficient_balance: 'No hay saldo suficiente para esta operación.',
        invalid_category: 'El carnet de conducir no tiene la categoría B.',
        invalid_status: 'La verificación del carnet de conducir no se ha completado.',
        label_not_applicable_to_pooling_route: 'Esta etiqueta no se puede asignar a viajes.',
        label_not_applicable_to_user: 'Esta etiqueta no se puede asignar a usuarios.',
        last_default_bank_account: 'Es la única cuenta bancaria: añade otra antes de eliminarla.',
        license_data_unreadable: 'No se han podido leer todos los datos del carnet de conducir.',
        matricula_max_users: 'Esta matrícula ya tiene el máximo de usuarios asociados.',
        negative_balance_blocked: 'La cuenta tiene saldo negativo y está bloqueada hasta que lo regularice.',
        no_payment_method: 'La empresa no tiene ninguna tarjeta registrada.',
        not_pausable: 'Solo se pueden pausar las rutinas recurrentes.',
        overlap: 'La rutina coincide con otra rutina del usuario.',
        payment_in_progress: 'La retirada se está pagando ahora mismo. Recarga en unos minutos.',
        payout_failed: 'No se ha podido retirar el dinero. Inténtalo de nuevo.',
        payout_recording_failed: 'El pago se ha procesado pero no se ha podido registrar. No lo repitas: contacta con soporte.',
        pmst_disabled: 'La empresa ha desactivado el PMST.',
        polyline_unavailable: 'No se ha podido calcular la ruta del viaje. Inténtalo de nuevo.',
        recipient_not_cancellable: 'El incentivo de este destinatario ya no está pendiente.',
        reference_selfie_missing: 'No hay selfie de referencia: hay que verificar la identidad antes.',
        route_not_active: 'El viaje no está pendiente ni en curso.',
        route_not_driver: 'Este viaje es de pasajero y no tiene desglose de precio.',
        routine_limit_reached: 'El usuario ha alcanzado el máximo de rutinas activas.',
        routine_not_flexible: 'Esta opción solo está disponible para rutinas flexibles.',
        seat_limit_reached: 'Se han agotado las plazas del plan de la empresa.',
        stripe_account_not_created: 'Todavía no hay cuenta de cobro: se crea al añadir la primera cuenta bancaria.',
        stripe_connect_id_missing: 'La empresa no tiene cuenta de cobro configurada.',
        trial_locked: 'La prueba de tu empresa ha terminado. Completa tu cuenta en Plan para seguir usando el dashboard.',
        user_profile_not_verified: 'Hay que verificar la identidad antes de retirar saldo.',
        vehicle_overlap: 'El vehículo ya está en otra rutina en las mismas fechas y horarios.',
        user_whitelisted: 'El usuario está en la lista blanca de fraude: sácalo de ella antes de ponerlo en verificación reforzada.',
        week_has_matches: 'Esa semana ya tiene matches y no se puede replanificar.',
        without_cost_distance_exceeded: 'El viaje sin coste supera la distancia máxima permitida.',
        without_cost_not_allowed: 'Este usuario no puede crear viajes sin coste.',
        // Catálogo de eventos del backoffice (trips-core)
        event_category_base: 'Esta categoría no se puede borrar. Puedes desactivarla.',
        event_category_in_use: 'No se puede borrar una categoría con eventos. Puedes desactivarla.',
        event_has_linked_routines: 'No se puede cambiar la fecha, la hora ni la ubicación del evento: tiene viajes que aún no han salido.',
        event_has_trips: 'No se puede borrar un evento con viajes. Cancélalo en su lugar.',
        ticketmaster_not_configured: 'La consulta a Ticketmaster no está configurada en el servidor.',
        ticketmaster_unavailable: 'Ahora mismo no se puede consultar Ticketmaster. Inténtalo de nuevo en unos minutos.',
        football_data_not_configured: 'La consulta a football-data no está configurada en el servidor.',
        football_data_unavailable: 'Ahora mismo no se puede consultar football-data. Inténtalo de nuevo en unos minutos.',
        football_data_no_category: 'No hay ninguna categoría activa de fútbol ni de deporte para los partidos.',
      },

      // `code` de autenticación (AuthErrorCodeEnum). Otro `code` no se traduce
      AUTH: {
        AUTH_CREDENTIAL_MISSING: 'Se requiere autenticación para acceder a este recurso.',
        AUTH_CREDENTIAL_FORMAT_INVALID: 'La credencial de acceso no tiene un formato válido.',
        AUTH_CREDENTIAL_INTEGRITY_INVALID: 'La credencial de acceso no es válida.',
        AUTH_SESSION_EXPIRED_X0001: 'Tu sesión ha expirado. Inicia sesión de nuevo.',
        AUTH_SESSION_EXPIRED_X0002: 'Tu sesión ha expirado. Inicia sesión de nuevo.',
        AUTH_SESSION_EXPIRED_X0003: 'Tu sesión ha expirado. Inicia sesión de nuevo.',
        AUTH_SESSION_REFERENCE_MISSING: 'No se ha podido identificar la sesión.',
        AUTH_SESSION_NOT_FOUND: 'La sesión ya no está disponible.',
        AUTH_SESSION_REVOKED: 'La sesión ya no está activa. Inicia sesión de nuevo.',
        AUTH_IDENTITY_NOT_FOUND: 'La identidad asociada a la sesión no está disponible.',
        AUTH_APPLICATION_NOT_ALLOWED: 'La aplicación de acceso no está permitida.',
        AUTH_ACCESS_CONTEXT_MISMATCH: 'El contexto de acceso no es válido para este recurso.',
        AUTH_CREDENTIAL_REJECTED: 'La credencial de acceso ha sido rechazada.',
        AUTH_REQUIRED: 'Se requiere autenticación para acceder a este recurso.',
        AUTH_PERMISSION_DENIED: 'No tienes permisos para acceder a este recurso.',
        AUTH_BACKOFFICE_PERMISSION_DENIED: 'No tienes permisos para acceder al backoffice.',
        AUTH_CHANNEL_REQUIRED: 'Se requiere autenticación para este canal.',
        AUTH_CHANNEL_PERMISSION_DENIED: 'No tienes permisos suficientes para este canal.',
        AUTH_TEMPORARILY_UNAVAILABLE: 'El servicio de autenticación no está disponible temporalmente.',
        AUTH_INTERNAL_ERROR: 'No se ha podido completar la validación de acceso.',
      },

      // Nombre de los campos en los mensajes de validación; sin entrada, el
      // nombre técnico con espacios (start_date → «start date»)
      FIELD: {
        name: 'nombre',
        surname: 'apellidos',
        email: 'correo electrónico',
        password: 'contraseña',
        phone: 'teléfono',
        code: 'código',
        label: 'etiqueta',
      },

      // Reglas de validación de `failed_rules`. {{field}} es el campo; {{p0}},
      // {{p1}} sus parámetros y {{values}} todos ellos separados por comas.
      RULE: {
        accepted: 'Hay que aceptar el campo {{field}}.',
        after: 'El campo {{field}} debe ser una fecha posterior a {{p0}}.',
        after_or_equal: 'El campo {{field}} debe ser una fecha igual o posterior a {{p0}}.',
        alpha: 'El campo {{field}} solo puede contener letras.',
        alpha_dash: 'El campo {{field}} solo puede contener letras, números, guiones y guiones bajos.',
        alpha_num: 'El campo {{field}} solo puede contener letras y números.',
        array: 'El campo {{field}} debe ser una lista.',
        before: 'El campo {{field}} debe ser una fecha anterior a {{p0}}.',
        before_or_equal: 'El campo {{field}} debe ser una fecha igual o anterior a {{p0}}.',
        between: 'El campo {{field}} debe estar entre {{p0}} y {{p1}}.',
        boolean: 'El campo {{field}} debe ser verdadero o falso.',
        confirmed: 'La confirmación del campo {{field}} no coincide.',
        current_password: 'La contraseña no es correcta.',
        date: 'El campo {{field}} no es una fecha válida.',
        date_equals: 'El campo {{field}} debe ser la fecha {{p0}}.',
        date_format: 'El campo {{field}} no tiene el formato {{p0}}.',
        decimal: 'El campo {{field}} debe tener {{values}} decimales.',
        different: 'Los campos {{field}} y {{p0}} deben ser distintos.',
        digits: 'El campo {{field}} debe tener {{p0}} dígitos.',
        digits_between: 'El campo {{field}} debe tener entre {{p0}} y {{p1}} dígitos.',
        dimensions: 'La imagen del campo {{field}} no tiene unas dimensiones válidas.',
        distinct: 'El campo {{field}} tiene un valor repetido.',
        email: 'El campo {{field}} debe ser un correo electrónico válido.',
        ends_with: 'El campo {{field}} debe terminar en uno de estos valores: {{values}}.',
        enum: 'El valor seleccionado en {{field}} no es válido.',
        exists: 'El valor seleccionado en {{field}} no es válido.',
        file: 'El campo {{field}} debe ser un archivo.',
        filled: 'El campo {{field}} debe tener un valor.',
        gt: 'El campo {{field}} debe ser mayor que {{p0}}.',
        gte: 'El campo {{field}} debe ser mayor o igual que {{p0}}.',
        image: 'El campo {{field}} debe ser una imagen.',
        in: 'El valor seleccionado en {{field}} no es válido.',
        in_array: 'El campo {{field}} no existe en {{p0}}.',
        integer: 'El campo {{field}} debe ser un número entero.',
        ip: 'El campo {{field}} debe ser una dirección IP válida.',
        json: 'El campo {{field}} debe ser un JSON válido.',
        lowercase: 'El campo {{field}} debe estar en minúsculas.',
        lt: 'El campo {{field}} debe ser menor que {{p0}}.',
        lte: 'El campo {{field}} debe ser menor o igual que {{p0}}.',
        max: 'El campo {{field}} supera el máximo permitido ({{p0}}).',
        max_digits: 'El campo {{field}} no puede tener más de {{p0}} dígitos.',
        mimes: 'El campo {{field}} debe ser un archivo de tipo: {{values}}.',
        mimetypes: 'El campo {{field}} debe ser un archivo de tipo: {{values}}.',
        min: 'El campo {{field}} no llega al mínimo permitido ({{p0}}).',
        min_digits: 'El campo {{field}} debe tener al menos {{p0}} dígitos.',
        multiple_of: 'El campo {{field}} debe ser múltiplo de {{p0}}.',
        not_in: 'El valor seleccionado en {{field}} no es válido.',
        not_regex: 'El formato del campo {{field}} no es válido.',
        numeric: 'El campo {{field}} debe ser un número.',
        password: 'La contraseña no cumple los requisitos de seguridad.',
        present: 'El campo {{field}} debe estar presente.',
        prohibited: 'El campo {{field}} no está permitido.',
        prohibited_if: 'El campo {{field}} no está permitido en este caso.',
        prohibited_unless: 'El campo {{field}} no está permitido en este caso.',
        prohibits: 'El campo {{field}} no permite rellenar {{values}} a la vez.',
        regex: 'El formato del campo {{field}} no es válido.',
        required: 'El campo {{field}} es obligatorio.',
        required_array_keys: 'Al campo {{field}} le faltan datos obligatorios.',
        required_if: 'El campo {{field}} es obligatorio en este caso.',
        required_unless: 'El campo {{field}} es obligatorio en este caso.',
        required_with: 'El campo {{field}} es obligatorio cuando se indica {{values}}.',
        required_with_all: 'El campo {{field}} es obligatorio cuando se indican {{values}}.',
        required_without: 'El campo {{field}} es obligatorio cuando no se indica {{values}}.',
        required_without_all: 'El campo {{field}} es obligatorio cuando no se indica ninguno de: {{values}}.',
        same: 'Los campos {{field}} y {{p0}} deben coincidir.',
        size: 'El campo {{field}} debe tener el tamaño {{p0}}.',
        starts_with: 'El campo {{field}} debe empezar por uno de estos valores: {{values}}.',
        string: 'El campo {{field}} debe ser un texto.',
        timezone: 'El campo {{field}} debe ser una zona horaria válida.',
        ulid: 'El campo {{field}} debe ser un identificador válido.',
        unique: 'El valor del campo {{field}} ya está en uso.',
        uploaded: 'No se ha podido subir el archivo de {{field}}.',
        uppercase: 'El campo {{field}} debe estar en mayúsculas.',
        url: 'El campo {{field}} debe ser una URL válida.',
        uuid: 'El campo {{field}} debe ser un identificador válido.',

        // Reglas escritas como clase en el backend (app/Rules), en snake_case
        base64_image: 'El campo {{field}} debe ser una imagen png, jpeg, jpg o webp en base64 de 4 MB como máximo.',
        referral_phone_country: 'El teléfono debe ser de España (+34) o Francia (+33) y tener los dígitos correctos.',
        reclamation_subcategory_belongs_to_category: 'La subcategoría no pertenece a la categoría indicada.',
        ride_product_description_locales: 'La descripción solo admite los idiomas es, en y ca.',
        safe_reclamation_snapshot: 'El campo {{field}} no es válido: es demasiado grande, demasiado anidado o contiene datos sensibles.',
        unique_user_document: 'El documento de identidad no es válido o ya está asociado a otra cuenta.',
        valid_phone: 'El formato del teléfono no es válido.',
        valid_user_origin: 'El valor de origen no es válido o no existe.',
      },
    },
  },
};
